import React from 'react'
import PropTypes from 'prop-types'

import Table from './Table'

import {
  wellnessMetricsKeyNameList,
  measurementKeyNameList,
} from '../../measurements/measurement_names'

const selectedWellnessMetrics = [
  'bfp4',
  'bmi',
  'bmr',
  'bodyShapeRating',
  'fatMass',
  'height',
  'leanMass',
  'trunkLegVolRatio',
  'wc',
  'weight',
  'weightManual',
  'whr',
]

const selectedMeasurements = [
  'neckCollarGirth',
  'chestAtBladesGirth',
  'bustGirth',
  'underbustGirth',
  'waistSmallBackGirth',
  'seatGirth',
  'bicepsLeftGirth',
  'bicepsRightGirth',
  'forearmLeftGirth',
  'forearmRightGirth',
  'thighLeftMaxGirth',
  'thighRightMaxGirth',
  'calfLeftGirth',
  'calfRightGirth',
  'ankleLeftGirth',
  'ankleRightGirth',
  'hipTopGirth',
  'elbowLeftGirth',
  'elbowRightGirth',
  'wristLeftGirth',
  'wristRightGirth',
  'kneeLeftGirth',
  'kneeRightGirth',
]

const WellnessTable = ({ wellnessMetrics }) => {
  const table = []
  const wellnessMetricsCopy = selectedWellnessMetrics.slice() // don't modify selectedWellnessMetrics
  while (wellnessMetricsCopy.length > 0) {
    const metrics = wellnessMetricsCopy.splice(0, 2)
    table.push(
      <tr key={metrics[0] + metrics[1]}>
        <td style={{ width: '285px', padding: '4px 6px', borderRight: 'none' }}>
          {wellnessMetricsKeyNameList[metrics[0]]}
        </td>
        <td style={{ width: '285px', padding: '4px 6px', borderLeft: 'none' }}>
          {wellnessMetrics.get(metrics[0])}
        </td>
        <td style={{ width: '285px', padding: '4px 6px', borderRight: 'none' }}>
          {wellnessMetricsKeyNameList[metrics[1]]}
        </td>
        <td style={{ width: '285px', padding: '4px 6px', borderLeft: 'none' }}>
          {wellnessMetrics.get(metrics[1])}
        </td>
      </tr>
    )
  }
  return <Table table={table} />
}

const MeasurementTable = ({ measurements }) => {
  const table = []
  const measurementsCopy = selectedMeasurements.slice()
  while (measurementsCopy.length > 0) {
    const metrics = measurementsCopy.splice(0, 2)
    table.push(
      <tr key={metrics[0] + metrics[1]}>
        <td style={{ width: '285px', padding: '4px 6px', borderRight: 'none' }}>
          {measurementKeyNameList[metrics[0]]}
        </td>
        <td style={{ width: '285px', padding: '4px 6px', borderLeft: 'none' }}>
          {measurements.get(metrics[0])}
        </td>
        <td style={{ width: '285px', padding: '4px 6px', borderRight: 'none' }}>
          {measurementKeyNameList[metrics[1]]}
        </td>
        <td style={{ width: '285px', padding: '4px 6px', borderLeft: 'none' }}>
          {measurements.get(metrics[1])}
        </td>
      </tr>
    )
  }
  return <Table table={table} />
}

MeasurementTable.propTypes = {
  measurements: PropTypes.object,
}

const snapMetricsKeyNameList = {
  body_fat_percentage: 'Body Fat %',
  lean_mass_percentage: 'Lean Mass %',
  fat_mass: 'Fat Mass (kg)',
  lean_mass: 'Lean Mass (kg)',
  vat_percentage: 'VAT %',
  vat_mass: 'VAT Mass (kg)',
  metabolic_age_years: 'Metabolic Age',
  bodyfat_method: 'BF Method',
  bmi_predicted: 'BMI (Predicted)',
  waist_to_hip_ratio: 'Waist-Hip Ratio',
  neck_circumference: 'Neck (cm)',
  chest_circumference: 'Chest (cm)',
  waist_circumference: 'Waist (cm)',
  hip_circumference: 'Hip (cm)',
}

const snapMetricsFields = Object.keys(snapMetricsKeyNameList)

const SnapMetricsTable = ({ snapMetrics }) => {
  const table = []
  const fields = snapMetricsFields.slice()
  while (fields.length > 0) {
    const metrics = fields.splice(0, 2)
    table.push(
      <tr key={metrics[0] + (metrics[1] || '')}>
        <td style={{ width: '285px', padding: '4px 6px', borderRight: 'none' }}>
          {snapMetricsKeyNameList[metrics[0]]}
        </td>
        <td style={{ width: '285px', padding: '4px 6px', borderLeft: 'none' }}>
          {snapMetrics.get(metrics[0]) != null
            ? String(snapMetrics.get(metrics[0]))
            : '—'}
        </td>
        {metrics[1] ? (
          <>
            <td
              style={{
                width: '285px',
                padding: '4px 6px',
                borderRight: 'none',
              }}
            >
              {snapMetricsKeyNameList[metrics[1]]}
            </td>
            <td
              style={{ width: '285px', padding: '4px 6px', borderLeft: 'none' }}
            >
              {snapMetrics.get(metrics[1]) != null
                ? String(snapMetrics.get(metrics[1]))
                : '—'}
            </td>
          </>
        ) : (
          <>
            <td
              style={{
                width: '285px',
                padding: '4px 6px',
                borderRight: 'none',
              }}
            />
            <td
              style={{ width: '285px', padding: '4px 6px', borderLeft: 'none' }}
            />
          </>
        )}
      </tr>
    )
  }
  return <Table table={table} />
}

const MetricsTable = ({ measurements, wellnessMetrics, snapMetrics }) => (
  <>
    {wellnessMetrics && (
      <div className="mb-3">
        <WellnessTable wellnessMetrics={wellnessMetrics} />
      </div>
    )}
    {measurements && <MeasurementTable measurements={measurements} />}
    {snapMetrics && (
      <div className="mt-3">
        <h6>Snap Metrics (Prism)</h6>
        <SnapMetricsTable snapMetrics={snapMetrics} />
      </div>
    )}
  </>
)

export default MetricsTable
